// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Click to view full leaderboard`
};

const de_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Klicken Sie, um die vollständige Rangliste anzuzeigen`
};

const es_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Haz clic para ver la tabla de clasificación completa`
};

const fr_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Cliquez pour voir le classement complet`
};

const fi_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Klikkaa nähdäksesi täydellisen tulostaulun`
};

const ja_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `完全なリーダーボードを表示するにはクリック`
};

const nl_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Klik om het volledige leaderboard te bekijken`
};

const pt_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Clique para ver a classificação completa`
};

const ro_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Faceți clic pentru a vedea clasamentul complet`
};

const th_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `คลิกเพื่อดูลีดเดอร์บอร์ดแบบเต็ม`
};

const ur_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `مکمل لیڈر بورڈ دیکھنے کے لیے کلک کریں`
};

const zh_hant1_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `點擊查看完整排行榜`
};

const da_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Klik for at se den fulde rangliste`
};

const it_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Clicca per vedere la classifica completa`
};

const vn_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Nhấp để xem bảng xếp hạng đầy đủ`
};

const ko_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `전체 리더보드를 보려면 클릭하세요`
};

const tr_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Tam skor tablosunu görmek için tıklayın`
};

const lv_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Noklikšķiniet, lai skatītu pilnu līderu tabulu`
};

const ar_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `انقر لعرض لوحة المتصدرين الكاملة`
};

const bs_widget_leaderboard_click_to_view = /** @type {(inputs: {}) => string} */ () => {
	return `Kliknite da vidite kompletnu tabelu rezultata`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_click_to_view = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_click_to_view(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_click_to_view", locale)
	if (locale === "en") return en_widget_leaderboard_click_to_view(inputs)
	if (locale === "de") return de_widget_leaderboard_click_to_view(inputs)
	if (locale === "es") return es_widget_leaderboard_click_to_view(inputs)
	if (locale === "fr") return fr_widget_leaderboard_click_to_view(inputs)
	if (locale === "fi") return fi_widget_leaderboard_click_to_view(inputs)
	if (locale === "ja") return ja_widget_leaderboard_click_to_view(inputs)
	if (locale === "nl") return nl_widget_leaderboard_click_to_view(inputs)
	if (locale === "pt") return pt_widget_leaderboard_click_to_view(inputs)
	if (locale === "ro") return ro_widget_leaderboard_click_to_view(inputs)
	if (locale === "th") return th_widget_leaderboard_click_to_view(inputs)
	if (locale === "ur") return ur_widget_leaderboard_click_to_view(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_click_to_view(inputs)
	if (locale === "da") return da_widget_leaderboard_click_to_view(inputs)
	if (locale === "it") return it_widget_leaderboard_click_to_view(inputs)
	if (locale === "vn") return vn_widget_leaderboard_click_to_view(inputs)
	if (locale === "ko") return ko_widget_leaderboard_click_to_view(inputs)
	if (locale === "tr") return tr_widget_leaderboard_click_to_view(inputs)
	if (locale === "lv") return lv_widget_leaderboard_click_to_view(inputs)
	if (locale === "ar") return ar_widget_leaderboard_click_to_view(inputs)
	if (locale === "bs") return bs_widget_leaderboard_click_to_view(inputs)
	return "widget_leaderboard_click_to_view"
};